const UTM_PARAM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_id',
  'utm_term',
  'utm_content',
];

const STORAGE_KEY = 'tracking:utm_params';

type UTMParams = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_id?: string;
  utm_term?: string;
  utm_content?: string;
};

export default () => {
  const register = () => {
    const params = Array.from(new URLSearchParams(window.location.search))
      .filter(([key]) => UTM_PARAM_KEYS.includes(key))
      .reduce((acc, [key, value]) => {
        acc[key] = value;

        return acc;
      }, {});

    if (Object.keys(params).length > 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    }
  };

  register();

  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY)) as UTMParams;

    if (value) {
      return value;
    }

    return {};
  } catch {
    return {};
  }
};
